const data = {
  reelSrc: "/videos/sample/master.m3u8", // or "/videos/sample/preview.mp4" if not using HLS yet
  reelPoster: "/images/reel_poster.jpg",
  projects: [
    {
      slug: "pool-scum-session",
      title: "Pool Scum — Studio Session",
      client: "Pool Scum",
      role: ["Director", "DP", "Editor"],
      tags: ["Music Video", "Studio", "Gritty"],
      src: "/videos/sample/master.m3u8",
      previewSrc: "/videos/sample/preview.mp4", // 6–10s silent loop is ideal
      poster: "/images/poolscum_poster.jpg",
      description:
        "Shot handheld with vintage glass; moody grade; hard flash stills.",
    },
  ],
  gallery: [
    { thumb: "/photos/t1.webp", full: "/photos/f1.webp", alt: "Portrait" },
    { thumb: "/photos/t2.webp", full: "/photos/f2.webp", alt: "Live show" },
  ],
};

export default data;